export default __webpack_public_path__ + "static/graphik-web-bold-4fd3f9a644ab8fa5a559f292a9dd4046.woff";